export class PublishStepperLabels {
    static readonly PUBLISH_MODEL_TO_SENTIENCE = 'Publish Model to Cloud';
    static readonly CREATE_SKYSPARK_PROJECT = 'Create Analytics Project';
    static readonly ENABLE_EXTENSIONS = 'Enable Extensions';
    static readonly AUTO_CONFIGURE_RULES = 'Auto Configure Rules';
    static readonly CREATE_DATABASE = 'Create Database';
    static readonly CREATE_TABLES = 'Create Tables';
    static readonly ENABLE_DASHBOARDS = 'Enable Dashboards';
    static readonly EXPORT_MODEL_TO_SKYSPARK = 'Export Model to Analytics';
    static readonly SKYSPARK_RETRIEVAL = 'Retrieve Analytics';
}
